import { atom } from 'recoil';

export const isVoiceSettingsOpen = atom({
  key: 'isVoiceSettingsOpenState',
  default: false
});